import React from 'react';

export const EditSvg = () => (
  <svg
    width="72px"
    height="72px"
    viewBox="0 0 72 72"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <rect
        id="edit-path-1"
        x="0"
        y="0"
        width="39.5456604"
        height="26.4679245"
        rx="4.64"
      />
    </defs>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-951, -155)">
        <g transform="translate(951, 155)">
          <path
            d="M0,36 C0,16.1187272 16.1197409,0 36.002264,0 C55.8847871,0 72,16.1187272 72,36 C72,55.8812728 55.8802591,72 36.002264,72 C16.1242689,72 0,55.8767451 0,36"
            fill="#d1e4ed"
            fillRule="nonzero"
          />
          <g transform="translate(16.2294, 14.9706)">
            <mask id="edit-mask-2" fill="white">
              <use xlinkHref="#edit-path-1" />
            </mask>
            <g mask="url(#edit-mask-2)" fillRule="nonzero">
              <g transform="translate(-0.0966, 0)">
                <rect
                  fill="#FEFEFE"
                  x="0.0966357619"
                  y="0"
                  width="39.5456604"
                  height="26.4679245"
                  rx="4.64"
                />
                <path
                  d="M9.05533724,20.3639637 L14.8123184,20.3639637 C17.8830216,20.3639637 20.3723184,22.8532605 20.3723184,25.9239637 L20.3723184,31.6809448 C20.3723184,34.751648 17.8830216,37.2409448 14.8123184,37.2409448 L9.05533724,37.2409448 C5.98463403,37.2409448 3.49533724,34.751648 3.49533724,31.6809448 L3.49533724,25.9239637 C3.49533724,22.8532605 5.98463403,20.3639637 9.05533724,20.3639637 Z"
                  fill="#EAEAEA"
                  transform="translate(11.9338, 28.8025) rotate(45) translate(-11.9338, -28.8025)"
                />
                <path
                  d="M20.9773292,16.3747064 L30.0399707,16.3747064 C33.1106739,16.3747064 35.5999707,18.8640032 35.5999707,21.9347064 L35.5999707,30.997348 C35.5999707,34.0680512 33.1106739,36.557348 30.0399707,36.557348 L20.9773292,36.557348 C17.906626,36.557348 15.4173292,34.0680512 15.4173292,30.997348 L15.4173292,21.9347064 C15.4173292,18.8640032 17.906626,16.3747064 20.9773292,16.3747064 Z"
                  fill="#EAEAEA"
                  transform="translate(25.5086, 26.466) rotate(45) translate(-25.5086, -26.466)"
                />
                <circle
                  fill="#EAEAEA"
                  cx="10.389466"
                  cy="8.44981132"
                  r="3.10641509"
                />
              </g>
            </g>
          </g>
          <rect
            fill="#88AFBB"
            fillRule="nonzero"
            x="24.9826415"
            y="54.4754717"
            width="22.0392453"
            height="6.62490566"
            rx="3.31245283"
          />
          <rect
            fill="#88AFBB"
            fillRule="nonzero"
            x="20.4090566"
            y="47.1441509"
            width="31.1864151"
            height="3.00226415"
            rx="1.50113208"
          />
          <path
            d="M50.3230189,52.3109434 L50.3683019,52.410566 C50.7124528,53.0581132 51.6996226,52.9992453 51.9441509,52.2701887 L53.0445283,48.9690566 L57.8626415,53.4883019 C58.2022642,53.805283 58.7320755,53.7962264 59.0626415,53.4701887 L61.6483019,50.8845283 L61.7207547,50.8030189 C61.9879245,50.4588679 61.9562264,49.9562264 61.6256604,49.6483019 L56.9116981,45.2332075 L60.0135849,44.2007547 C60.7788679,43.9471698 60.8060377,42.8739623 60.0588679,42.5796226 L45.8354717,36.9735849 C45.1335849,36.6973585 44.4407547,37.3901887 44.7169811,38.0920755 L50.3230189,52.3154717 L50.3230189,52.3109434 Z"
            fill="#0B4575"
            fillRule="nonzero"
          />
        </g>
      </g>
    </g>
  </svg>
);
